import { useEffect, useState } from "react";

import { callServer, HttpMethod } from "store/utils/client";

type DefaultPricing = {
  annualPrice: number;
  monthlyPrice: number;
};

const FALLBACK: DefaultPricing = { annualPrice: 1200, monthlyPrice: 125 };

let globalCache: DefaultPricing | null = null;

export function useDefaultPricing(): DefaultPricing {
  const [pricing, setPricing] = useState<DefaultPricing>(
    globalCache ?? FALLBACK,
  );

  useEffect(() => {
    if (globalCache) return;

    let cancelled = false;
    (async () => {
      try {
        const response = await callServer<DefaultPricing>(
          { method: HttpMethod.Get, url: "v1/billing/default-pricing" },
          { notifyOnError: false },
        );
        if (!cancelled && response) {
          globalCache = response;
          setPricing(response);
        }
      } catch {
        // keep fallback
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return pricing;
}
